import { isAuth } from '@/services/PermissionService';
import Content from '@/components/layout/Content';
import Names from './names';
import { hasPermission, OWNER, SUPER_ADMIN, MANAGER } from '@/middlewares/permissions';
export default {
	path: '/reports',
	component: Content,
	children: [
		{
			path: '/reports',
			redirect: '/reports/DynamicReports',
		},
		{
			path: 'dynamicReports',
			name: Names.DynamicReports,
			component: () => import('../views/reports/DynamicReports'),
			meta: {
				title: 'Dynamic Reports',
				middleware: [isAuth, (nav) => hasPermission(nav, [OWNER], [SUPER_ADMIN, OWNER, MANAGER])],
			},
		},
	],
};
